module.exports = "/_next/static/images/menu-dev-f8bdf53c78d51d5425a0c1dd53885c31.png";